import React from 'react'

export const ScheduleIcon = ({
  height = 16,
  width = 16
}: {
  height?: number
  width?: number
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        // eslint-disable-next-line max-len
        d='M5.33203 6.36849H13.6654M2.33203 6.36849H2.66536M5.33203 12.9685H13.6654M2.33203 12.9685H2.66536M5.33203 9.63517H13.6654M2.33203 9.63517H2.66536M5.33203 3.03516H13.6654M2.33203 3.03516H2.66536'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
